import { render, staticRenderFns } from "./SyaratKetentuan.vue?vue&type=template&id=bb991b9c&scoped=true"
import script from "./SyaratKetentuan.vue?vue&type=script&lang=js"
export * from "./SyaratKetentuan.vue?vue&type=script&lang=js"
import style0 from "./SyaratKetentuan.vue?vue&type=style&index=0&id=bb991b9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb991b9c",
  null
  
)

export default component.exports